(function() {
    'use strict';
    /**
     * @memberof app
     *@ngdoc service
     *@name paginaService
     *@description
     *Servicio de autores
     */

    angular
        .module('app')
        .factory('paginaService', paginaService);

    paginaService.$inject = ["$http"];

    function paginaService($http) {    

    	var paginas = {};

    	/**
        * @ngdoc method
        * @name getPagina
        * @memberof paginaService
        * @desciption
        * Obtienes las paginas.
        */
    	paginas.getPagina = function (slug){
            var url= '/api/v1/pagina';
             return $http({
                method  : 'GET',
                url     : url,
                params	: {
                	"slug":slug,
                    "lang":language

                }
            })
                .then(Success)
                .catch(Failed);
            
            function Success(data){  
            	
                return data.data.page;
            }

            function Failed(data){
                console.log(data);
                return false;
            }
        };


    	return paginas;
    }



})();
